import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BILLING_CATEGORY } from "./apiRoutes";

interface UseGetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBillingCategoryDropdown = async (communityId: string) =>
  await axiosAuth.get(`${BILLING_CATEGORY}/community/${communityId}/dropdown`);

const useGetBillingCategoryDropdown = ({
  communityId,
  queryParams,
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-category-dropdown", communityId],
    queryFn: () => getBillingCategoryDropdown(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBillingCategoryDropdown;
